/** Medialuotsi whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { medialuoDefaultTheme } from './default';

export { medialuoWhitelabel } from './default';

export const medialuoWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: medialuoDefaultTheme,
  },
};
